

import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ManagerHeader from "./ManagerHeader";
import Navbar from "./Navbar";
const AffiliateRequests = () => {
  const [requests, setRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedInfluencerId, setSelectedInfluencerId] = useState("");
  const [trackingIdInput, setTrackingIdInput] = useState("");

  const requestsPerPage = 10;

  const fetchRequests = async () => {
    try {
      const response = await axios.get("https://server-side-influencer.onrender.com/manager/all-affiliate-requests");
      if (response.data.success) {
        setRequests(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching affiliate requests:", error);
      toast.error("Failed to load requests.");
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const indexOfLast = currentPage * requestsPerPage;
  const indexOfFirst = indexOfLast - requestsPerPage;
  const currentRequests = requests.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(requests.length / requestsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const openModal = (influencerId) => {
    setSelectedInfluencerId(influencerId);
    setTrackingIdInput("");
    setShowModal(true);
  };

  const handleAssignTrackingId = async () => {
    if (!trackingIdInput.trim()) {
      toast.error("Please enter a tracking ID.");
      return;
    }

    try {
      const response = await axios.post("https://server-side-influencer.onrender.com/manager/assign-tracking-id", {
        influencerId: selectedInfluencerId,
        trackingId: trackingIdInput.trim(),
      });

      if (response.data.message === "Tracking ID assigned and email sent to influencer") {
        toast.success("Tracking ID assigned and email sent to influencer");
        setShowModal(false);
        fetchRequests();
      } else {
        toast.info(response.data.message || "Updated");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to assign tracking ID");
    }
  };

  return (
    <div className="flex h-screen">
      <div className="fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <ManagerHeader page="Influencer Affiliate Requests" />
      </div>
{/* dddsss */}
      <div className="flex-1 ml-10 mt-20 p-6 overflow-auto w-full">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          Influencer Affiliate Requests
        </h2>

        <div className="relative overflow-x-auto shadow-md sm:rounded-lg bg-white mt-4 ml-5">
          {requests.length === 0 ? (
            <div className="p-8 text-center text-gray-500 text-lg">No affiliate requests found.</div>
          ) : (
            <>
              <table className="w-full text-sm text-left text-gray-500 mt-10">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th className="px-6 py-3">Name</th>
                    <th className="px-6 py-3">Email</th>
                    <th className="px-6 py-3">Phone</th>
                    <th className="px-6 py-3">Instagram</th>
                    <th className="px-6 py-3">Followers</th>
                    <th className="px-6 py-3">Country</th>
                    <th className="px-6 py-3 whitespace-nowrap">Amazon Tracking ID</th>
                    <th className="px-6 py-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRequests.map((req) => (
                    <tr key={req._id} className="odd:bg-white even:bg-gray-50 border-b">
                      <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">{req.fullname}</td>
                      <td className="px-6 py-4">{req.email}</td>
                      <td className="px-6 py-4">{req.phone}</td>
                      <td className="px-6 py-4">
                        <a href={req.instagramURL} target="_blank" rel="noreferrer" className="text-blue-500 underline">
                          View
                        </a>
                      </td>
                      <td className="px-6 py-4">{req.instagramFollowers}</td>
                      <td className="px-6 py-4">{req.country}</td>
                      <td className="px-6 py-4">
                        {req.amazonTrackingId?.trim()
                          ? req.amazonTrackingId
                          : <span className="text-red-500 font-semibold">Pending</span>}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => openModal(req.influencerId._id)}
                          className="text-white whitespace-nowrap bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                        >
                          <AddIcon fontSize="small" className="mr-1" /> Add tracking ID
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {totalPages > 1 && (
                <div className="flex justify-center mt-6 space-x-2">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                  >
                    Prev
                  </button>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={`px-3 py-1 text-sm rounded ${
                        currentPage === index + 1 ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Modalssssss */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-bold mb-4">Assign Tracking ID</h2>
            <input
              type="text"
              placeholder="Enter Amazon Tracking ID"
              value={trackingIdInput}
              onChange={(e) => setTrackingIdInput(e.target.value)}
              className="w-full px-4 py-2 border rounded mb-4"
            />
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowModal(false)}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleAssignTrackingId}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
              >
                Add
              </button>
            </div>
          </div>
               <ToastContainer
        position="bottom-center" // 👈 This makes it show at the bottom-center
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
        </div>
      )}
    </div>
  );
};

export default AffiliateRequests;
